module.exports = "<div class=\"uk-form uk-margin\">\n  <input type=\"text\" class=\"uk-input uk-width-8-8\" #searchInput (keyup)=\"searchChanged(searchInput)\" placeholder=\"Search to filter\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/shared/search-input/search-input.component.html
// module id = ../../../../../src-admin/app/shared/search-input/search-input.component.html
// module chunks = main